import axios from '@plugins/axios'
import getSecret from '@utils/get-secret'
let serverUrl = getSecret('SERVER_URL');

export const getters = {
  getActivityFields() {
    return { 
            model: 'tasks_activity', 
            label: 'Activities',
            fields: [
              { key: 'name', label: 'Name', type: 'text', sortable: true, required: true },
              { key: 'description', label: 'Description', type: 'text', sortable: true, required: false },
              { key: 'ledger_account_code', label: 'Ledger Account Code', type: 'text', sortable: true, required: true },
              { key: 'ledger_account_equivalency', label: 'Ledger Account Equivalency', type: 'text', sortable: true, required: true },
              { key: 'cost_center_code', label: 'Cost Center Code', type: 'text', sortable: true, required: true },
              { key: 'requirements', label: 'Requirements', type: 'array_model', 
                model_source: 'Requirements', model_route: 'management/masters/requirements', 
                sortable: true, required: true, formatter: (value, key, item) => {
                return item.requirements.length
              }}
            ]}
  },
}

export const actions = {
  async fetchActivities(context, query = '') {
    return axios
      .get(`${serverUrl}/api/masters/activities/${query}`)
      .then((response) => {
        return response.data;
      })
  },

  async createActivities(context, { payload }) {
    return axios
      .post(`${serverUrl}/api/masters/activities/`, payload)
      .then((response) => {
        return response.data;
      })
  },

  async updateActivities(context, { payload }) {
    return axios
      .patch(`${serverUrl}/api/masters/activities/${payload.id}/`, payload)
      .then((response) => {
        return response.data;
      })
  },

  async deleteActivities(context, { id }) {
    return axios
      .delete(`${serverUrl}/api/masters/activities/${id}/`)
      .then((response) => {
        return response.data;
      })
  },

  fetchActivitiesOptions(context, query) {
    query = query || ''
    return axios.options(`${serverUrl}/api/masters/activities/${query}`).then((response) => {
      return response.data
    })
  },
}